<template>
  <div style="position: relative" class="d-flex align-items-center" v-click-outside="closeMenu">
    <div class="filter-label d-flex align-items-center" style="margin-top: 5px; cursor: pointer;" @click.stop="menuOpened = !menuOpened">
      <span class="mx-2" style="font-weight: bold; font-size: 20px;">
        {{ selectedFilter }}
      </span>
      <i class="las la-angle-up" v-if="menuOpened"></i>
      <i class="las la-angle-down" v-else></i>
    </div>
    <div style="position: relative"> 
      <common-menu
        custom_style="position: absolute; width: auto; top: 15px; cursor: pointer;" 
        :open_menu="menuOpened"
        :menu_items="InvoiceFilters"
        :selected_item="selectedFilter"
        @select_item="selectFilter"
      />
    </div>
  </div>
</template>

<script>

import CommonMenu from "./menu.vue"

export default {
  name: "invoice-filter",
  props: ["selected_tab"],
  components: {
    CommonMenu,
  },
  data() {
    return {
      menuOpened: false,
      InvoiceFilters: ["All", "Due", "Paid", "Settled", "Overdue"],
      selectedFilter: "All",
    };
  },
  methods: {
    openMenu(index) {
      if (this.open_menu_index === index) this.open_menu_index = null;
      else this.open_menu_index = index;
    },
    closeMenu(){
      this.menuOpened = false;
    },
    selectFilter(filter) {
      this.querying = true;
      this.selectedFilter = filter;
      this.$emit("filter", filter);
      this.menuOpened = false;
      this.querying = false;
    },
    selectTab(index) {
      this.$parent.selectTab(index);
    },
  },
};
</script>

<style scoped>

#dashboard-filter-container {
  /* padding: 20px 30px; */
  border-bottom: 1px solid #eaeaea;
}

#dashboard-filter-container .filter-label {
  margin-right: 2rem;
  color: #111111;
  font-size: 15px;
  font-family: "Quicksand-Bold";
  cursor: pointer;
  opacity: 0.5;
}
#dashboard-filter-container .filter-label:hover {
  opacity: 1;
}

#dashboard-filter-container .icon-btn {
  background-color: #eaeaea;
  border-radius: 6px;
  height: 39px;
  width: 39px;
  position: relative;
  cursor: pointer;
  margin-left: 1rem;
  opacity: 0.5;
}
#dashboard-filter-container .icon-btn:hover {
  background-color: #d3d3d3;
  opacity: 1;
}
#dashboard-filter-container .icon-btn.active {
  background-color: #d3d3d3;
  opacity: 1;
}
</style>
